import React from 'react';
import {
  IonCard,
  IonCardHeader,
  IonRow,
  IonChip,
  IonLabel,
  IonButton,
  IonCardContent,
  IonCardSubtitle,
  IonBadge
} from '@ionic/react';
import { setAppointment } from '../store/actions/appointments';
import { Appointment } from '../models';
import { connect } from 'react-redux';
import Laboratory from '../models/Laboratory';
import { nl2brJSX } from '../utils/nl2br';
import AccordionItem from './AccordionItem';
import './LaboratoryCard.css';

const mapStateToProps = (ownProps: any) => {
  return {};
};

const mapDispatchToProps = (dispatch: Function, ownProps: any) => ({
  selectLaboratory: (appointment: Partial<Appointment>) =>
    dispatch(setAppointment(appointment))
});

type LaboratoryCardProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps> & {
    laboratory: Laboratory;
    onSelect: Function;
  };

const LaboratoryCard: React.FC<LaboratoryCardProps> = ({
  laboratory,
  selectLaboratory,
  onSelect = () => false
}) => {
  return (
    <IonCard class="ion-text-start">
      <IonCardHeader>
        <IonRow class="ion-justify-content-between ion-align-items-start ion-nowrap">
          <IonChip className="ion-text-wrap ion-height-auto laboratory-card__title">
            <IonLabel>{laboratory.name}</IonLabel>
          </IonChip>
          {laboratory.appointment_type !== 'none' ? (
            laboratory.appointment_type !== 'direct_only' ? (
              <IonButton
                size="small"
                onClick={() => {
                  selectLaboratory({ laboratory });
                  onSelect(laboratory);
                }}
              >
                Choisir
              </IonButton>
            ) : (
              <IonBadge
                className="laboratory-card__unavailable"
                style={{ maxWidth: '50%', whiteSpace: 'normal' }}
              >
                Ce laboratoire est disponible
                <br />
                uniquement sans rendez-vous
              </IonBadge>
            )
          ) : (
            <IonBadge className="laboratory-card__unavailable">
              Prochainement
              <br />
              disponible en ligne
            </IonBadge>
          )}
        </IonRow>
      </IonCardHeader>
      <IonCardContent>
        {nl2brJSX(laboratory.address.replace(', France', ''), ',')}
        {laboratory.distance ? (
          <>
            <IonCardSubtitle className="ion-margin-top">
              Distance
            </IonCardSubtitle>
            {laboratory.distance.toFixed(0)}km
          </>
        ) : null}
        {laboratory.phone ? (
          <>
            <IonCardSubtitle className="ion-margin-top">
              Numéro de téléphone
            </IonCardSubtitle>
            {laboratory.phone}
          </>
        ) : null}
      </IonCardContent>
      <div className="ion-no-padding laboratory-card__more-info">
        <AccordionItem name="Plus d'informations">
          {laboratory.timetable ? (
            <>
              <IonCardSubtitle>Horaires</IonCardSubtitle>
              {laboratory.timetable}
            </>
          ) : null}
          {laboratory.specific_analyses ? (
            <>
              <IonCardSubtitle className="ion-margin-top">
                Analyses spécifiques
              </IonCardSubtitle>
              {laboratory.timetable}
            </>
          ) : null}
          {laboratory.accessibility ? (
            <>
              <IonCardSubtitle className="ion-margin-top">
                Accès PMR
              </IonCardSubtitle>
              {laboratory.accessibility}
            </>
          ) : null}
          {laboratory.at_home ? (
            <>
              <IonCardSubtitle className="ion-margin-top">
                Créneau de prise en charge à domicile
              </IonCardSubtitle>
              {laboratory.at_home}
            </>
          ) : null}
          {laboratory.external_link ? (
            <>
              <IonCardSubtitle className="ion-margin-top">
                <a
                  href={laboratory.external_link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Site internet
                </a>
              </IonCardSubtitle>
            </>
          ) : null}
        </AccordionItem>
      </div>
    </IonCard>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(LaboratoryCard);
